module.exports = __webpack_public_path__ + "af30193e4816dab3a820699a87983e20.png";